import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Brain, Compass, Target, Activity, BookOpen, ClipboardCheck, Trophy, LayoutDashboard, BarChart2 } from '../../icons';
import { SidebarLayout } from '../SidebarLayout';
import { useAuth } from '../../../contexts/AuthContext';
import { supabase } from '../../../lib/supabase';
import { LoadingSpinner } from '../../LoadingSpinner';
import type { SidebarItem } from '../Sidebar';

export function RespondentLayoutTR() {
  const navigate = useNavigate();
  const { user, isLoading: authLoading } = useAuth();
  const [authorized, setAuthorized] = useState(false);
  const [checking, setChecking] = useState(true);
  const [hasPathways, setHasPathways] = useState(false);

  useEffect(() => {
    if (authLoading) return;
    if (!user) {
      navigate('/tr/login');
      return;
    }

    const init = async () => {
      const { data: respondent } = await supabase
        .from('respondents')
        .select('id')
        .eq('user_id', user.id)
        .maybeSingle();

      if (!respondent) {
        navigate('/tr');
        return;
      }

      const { count } = await supabase
        .from('pathway_assignments')
        .select('*', { count: 'exact', head: true })
        .eq('respondent_user_id', user.id);

      setHasPathways((count || 0) > 0);
      setAuthorized(true);
      setChecking(false);
    };

    init();
  }, [user, authLoading, navigate]);

  if (authLoading || checking || !authorized) {
    return <LoadingSpinner message="Yükleniyor..." />;
  }

  const items: SidebarItem[] = [
    { group: 'Profil ve Örüntüler', label: 'Sonuçlarım', path: '/tr/dashboard', icon: Brain },
  ];

  if (hasPathways) {
    items.push({ group: 'Profil ve Örüntüler', label: 'Gelişim Yollarım', path: '/tr/dashboard/pathways', icon: Compass });
  }

  items.push(
    { group: 'İlerleme', label: 'Genel Bakış', path: '/tr/dashboard/progress', icon: LayoutDashboard },
    { group: 'İlerleme', label: 'Hedefler', path: '/tr/dashboard/progress/goals', icon: Target },
    { group: 'İlerleme', label: 'Alışkanlıklar', path: '/tr/dashboard/progress/habits', icon: Activity },
    { group: 'İlerleme', label: 'Görevler', path: '/tr/dashboard/progress/tasks', icon: ClipboardCheck },
    { group: 'İlerleme', label: 'Check-in', path: '/tr/dashboard/progress/check-ins', icon: Activity },
    { group: 'İlerleme', label: 'Günlük', path: '/tr/dashboard/progress/journal', icon: BookOpen },
    { group: 'İlerleme', label: 'Kilometre Taşları', path: '/tr/dashboard/progress/milestones', icon: Trophy },
    { group: 'Kanıt', label: 'Raporlarım', path: '/tr/dashboard/proof/reports', icon: BarChart2 },
  );

  return (
    <SidebarLayout
      items={items}
      title="Profilim"
      subtitle="Değerlendirme sonuçları ve gelişim"
    />
  );
}
